var exports = {
  "t": "PageDivider__1r7myA",
  "q": "PageDividerWrapper__E4qD-i",
};

module.exports = exports;
